<template>
    <div>
        <section class="section has-bottom-image">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <img class="text-center col-4 offset-4" src="./../assets/images/sent.svg" />
                        <h1 class="text-center">{{ $t('account.emailsend.title') }}</h1>
                        <p class="text-center">
                            {{ $t('account.emailsend.sub_title') }}
                        </p>
                        <div class="row">
                            <a
                                class="button--secondary button--rounded col-12 col-sm-6 push-sm-3"
                                href="https://www.tecnotion.com/"
                            >
                                {{ $t('account.buttons.homepage') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <img class="section__bottom_image" src="./../assets/images/tecnotion-blue.png" />
        </section>
        <EndSignUpMail id="endsignup" />
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import EndSignUpMail from '@/components/EndSignUpMail';

@Component({ components: { EndSignUpMail } })
export default class EmailSend extends Vue {
    //
}
</script>
